// @core/api/endpoints/workflow/get_node_type.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  NodeTypeResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Get node type
 * Retrieves a node type by its ID or slug, including input/output schemas and port definitions.
 */
export async function GetNodeType(
  node_type_id: string,
  options?: RequestOptions
): Promise<NodeTypeResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/node-types/:node_type_id`;
  requestPath = requestPath.replace(':node_type_id', encodeURIComponent(node_type_id));
  const requestOptions = options;
  return client.get<NodeTypeResponse>(requestPath, { ...requestOptions });
}
